import React from 'react';

function HomePage() {
    return (
        <>
            <section>
                <h2>Who We Are</h2>
            </section>
            <div class="content">
                <h3>The Midcoast Socialist Coalition is a group of comrades living in midcoast Maine and 
                    neighboring areas. We recognize a lack of support for the rights and interests of working 
                    people and our marginalized communities;  we exist to take on that work. Our Coalition 
                    seeks to identify and address socialist solutions to problems created by capitalism. We 
                    invite others to join MSC in building a socialist community on shared principles that are 
                    missing in other parts of our lives.</h3>
            </div>
            <section>
                <h2>What We Do</h2>
            </section>
            <div class ="content">
                <h3>Capitalism isn’t working for the people of our region, our country and our world. The 
                    Midcoast Socialist Coalition uses our resources to draw attention to, educate about, and 
                    organize against problems caused by capitalism and by the rise of authoritarianism. We 
                    must act with urgency due to the growing oligarchic influence in dominant 
                    American culture. As we strive to live in a more just and equitable world, we are honest 
                    with each other and respect all voices. Our work includes community service, rural 
                    organizing, and political action, all in a manner consistent with our aspiration to 
                    realize socialism.</h3>
            </div>
         </>
    );
}

export default HomePage;